"use client";

import React, { useState, useEffect } from "react";
import ControlPanel from "../../Layout/ControlPanel";
import Profile from "./Profile";

const TopNavbar = ({ user, toggleActive }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Check initial theme
    const htmlElement = document.documentElement;
    setIsDarkMode(htmlElement.getAttribute('data-bs-theme') === 'dark');

    // Scroll handler
    const handleScroll = () => {
      const elementId = document.getElementById("header");
      if (elementId) {
        if (window.scrollY > 170) {
          elementId.classList.add("sticky");
        } else {
          elementId.classList.remove("sticky");
        }
      }
    };

    document.addEventListener("scroll", handleScroll);

    // Observer for theme changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'data-bs-theme') {
          setIsDarkMode(document.documentElement.getAttribute('data-bs-theme') === 'dark');
        }
      });
    });

    observer.observe(document.documentElement, { attributes: true });

    return () => {
      document.removeEventListener("scroll", handleScroll);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <header
        className={`header-area mb-4 rounded-bottom-15 ${isDarkMode ? 'bg-dark' : 'bg-white'}`}
        id="header"
      >
        <div className="row align-items-center">
          <div className="col-lg-4 col-sm-6">
            <div className="left-header-content">
              <ul className="d-flex align-items-center ps-0 mb-0 list-unstyled justify-content-center justify-content-sm-start">
                <li>
                  <button
                    className={`header-burger-menu p-0 border-0 ${isDarkMode ? 'bg-transparent' : 'bg-transparent'}`}
                    onClick={toggleActive}
                    title="Toggle Menu"
                  >
                    <i className="material-symbols-outlined fs-24">menu</i>
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-8 col-sm-6">
            <div className="right-header-content mt-2 mt-sm-0">
              <ul className="d-flex align-items-center justify-content-center justify-content-sm-end ps-0 mb-0 list-unstyled">
                
                <li className="header-right-item">
                  <ControlPanel />
                </li>

                <li className="header-right-item">
                  <Profile user={user} />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default TopNavbar;
